
import GiropayForm from './GiropayForm.vue';
import { Button, Checkbox } from 'element-ui';
import hipayMixin from '../hipayMixin';

export default {
  mixins: [hipayMixin],
  props: {
    paymentMethod: {
      type: Object,
    },
  },
  data() {
    return {
      generalConditionsSale: false,
    };
  },
  computed: {},
  methods: {
    submit() {
      this.startPayment({
        paymentData: { payment_product: 'giropay' },
        paymentMethod: this.paymentMethod,
      });
    },
  },
  components: {
    Button,
    Checkbox,
    GiropayForm,
  },
};
